import { Component, OnInit } from '@angular/core';
import { FacilityService } from '../../shared/services/facility.service';
import { ApplicationDetail, ChangeType, DocumentDetail, FacilityDetail, PaymentInfoDetail, ChangeDraftApplicationModel, ChangeDraftDetail }
from '../../models/ApplicationDetail';
import { ApplicationService } from '../../shared/services/application.service';
import { DocumentRef } from '../../models/DocumentRef';
import { AlertService } from '../../shared/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AccountService } from '../../services/account.service';
import { UserDto } from '../../models/User';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../shared/services/settings.service';
import * as Constants from '../../models/Constants';
import {
  ApplicationChangeType,
  ChangeApplication,
  ChangeConfig, ChangeFeeConfig,
  ChecklistInstance,
  CheckListValueModel,
  PaymentInfo, Professionals, FacilityView, Organization, FacilitySpecificProductItem
} from '../../models/ApplicationModel';
import { FileLikeObject, FileUploader } from 'ng2-file-upload';
import { environment } from '../../../environments/environment';
import {
  FacilityType,
  City, EducationLevel,
  OwnershipType,
  ProductType,
  ProfessionalType,
  RegionType,
  SpecificProduct,
  SpecificProductItem,
  WoredaType,
  SubCityType,
  ZoneType,
  MLevel,
  MRLevel,
  FIRItem, QualificationType, DiplomaSelection, TinClaim
} from '../../models/CommonModels';
import { NumberValidator } from '../../validators/number.validator';
import { NO_SCRIPT_INPUT_MESSAGE, withNoScriptValidators } from '../../shared/validators/no-script-input.validator';
import { CommonService } from '../../shared/services/common.service';
import { ChecklistConfigModel } from '../../models/ChecklistModel';
import {ProfessionalConfigFilter, ProfessionalTypeConfig} from '../../models/ProfessionalType';
import {ErisLoginService} from '../../services/sso/eris-login.service';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

const URL = environment.baseUrl + '/Attachment';

@Component({
  selector: 'app-change-application',
  templateUrl: './change-application.component.html',
  styleUrls: ['./change-application.component.css', '../create/create-application.component.css',
    '../application-declaration-letter/application-declaration-letter.component.css']
})
export class ChangeApplicationComponent implements OnInit {
  public facilities: FacilityView[];
  public selectedFacilityId: number;
  public facilityTypes: FacilityType[];
  public changeSummary: string;
  public selectedFacility: FacilityView;
  public selectedAppDetail: ApplicationDetail;
  public selectedFacilityCategoryName: String;
  public changeFee: ChangeFeeConfig[] = [];
  public feeSum = 0;
  public documents: Array<DocumentDetail>;
  public documentRefs: Array<DocumentRef>;
  public restrictedDocRefCount: number;
  public showFee = false;
  public tab: string;
  public buttonName: string;
  public tabIndex: number;
  public tabList: Array<string> = ['changeDetail', 'fileAttachments'];
  public user: UserDto;
  public changeTypes: ChangeType[] = [];
  public selectedChangeTypes: ChangeType[] = [];
  public changeForm: FormGroup;
  public basicInfoFields: string[] = [];
  public professionalsField: string[] = [];
  public changeConfigs: ChangeConfig[] = [];
  public uploader: FileUploader;
  private allowedFileType = ['pdf'];
  private maxFileSize: number = 6 * 1024 * 1024; // 6 MB
  private uploadErrorMessage: string;
  public constants: any = Constants;
  public smLetterOfExperienceDocRequired: boolean = true;
  public changeChoiceReady = false;
  private plcEstablishmentDoc:any;
  private plcRequlationDoc:any;
  public showErrors = false;
  public editMode = false;
  public editDocuments: Array<DocumentDetail>;
  public professionalTypes: ProfessionalType[];
  public regionList: RegionType[] = [];
  public zoneList: ZoneType[] = [];
  public woredaList: WoredaType[] = [];
  public subCityList: SubCityType[] = [];
  public cityList: City[] = [];
  public specificProductList: SpecificProduct[] = [];
  public specificProductItems: SpecificProductItem[] = [];
  public productTypes: ProductType[];
  public mLevels: MLevel[];
  public mRLevels: MRLevel[];
  public allmRLevels: MRLevel[];
  public checklists: ChecklistConfigModel[];
  public noChecklistAvailable = false;
  public checklistInstances: ChecklistInstance[] = [];
  public newApplicationChangeTypes: ApplicationChangeType[] = [];
  private paymentInfo: PaymentInfo = null;
  public educationLevels: EducationLevel[];
  public addressChangeSelected = false;
  public premiseModificationSelected = false;
  private applicationId: number;
  private draftApplicationId: number;
  public draftMode: boolean;
  public FIStatus: boolean;
  public changeDraft: ChangeDraftApplicationModel
  private newSelectedChangeTypes: ChangeType[] = [];
  private showSpecificProductItem = false;
  public applicationDetail: ApplicationDetail;
  public professionalTypeConfigList: ProfessionalTypeConfig[];
  public fieldValue;
  public qualificationTypes: QualificationType[];
  public currentProfessionals: string[] = [];
  private allChangesLoaded = false;
  public tempCOC = false;
  public previousProductId = null;
  public ownershipTypes: OwnershipType[];
  public selectedOrganizationName: string;
  public selectedSpecificProductItems: FacilitySpecificProductItem[] = [];
  public specificProductItemForm : FormGroup;
  public modalRef: BsModalRef; 
  public modalTitle: string; 
  public indexOfSelectedSpecificProductItem: number = -1;
  public modalSpecificProductItems: SpecificProductItem[] = [];
  public showFoodManufacturerMenu: boolean = false;


  private professionalChanges = [Constants.HYGIENE_AND_SANITATION_EXPERT_NAME, Constants.STORE_MANAGER_NAME,
    Constants.QUALITY_ASSURANCE_NAME, Constants.Quality_CONTROL_NAME, Constants.PRODUCTION_MANAGER_NAME,
    Constants.TECHNICAL_LEADER_NAME, Constants.PHYSICO_CHEMICAL_EXPERT_Name, Constants.MICROBIOLOGIST_Name];
  showSubCity: boolean;
      
  constructor(private facilityService: FacilityService, private applicationService: ApplicationService, private fb: FormBuilder,
    private alertService: AlertService, private spinner: NgxSpinnerService, private accountService: AccountService,
    private route: ActivatedRoute, private router: Router, private commonService: CommonService,
    private settingsService: SettingsService, private erisLoginService: ErisLoginService, 
    private errorHandlerService: ErrorHandlerService, private modalService: BsModalService) {
    
    this.selectedFacilityId = parseInt(this.route.snapshot.queryParams.facilityId);
    this.applicationId = this.route.snapshot.params['id'];
    const draftMode = this.route.snapshot.params['draft'];
    this.draftMode = (/true/i).test(draftMode);
    this.tempCOC = this.route.snapshot.params['temp'];
    if(this.tempCOC){
      this.noChecklistAvailable = true;
    }
  }

  ngOnInit() {
    this.uploader = new FileUploader({
      url: URL,
      allowedFileType: this.allowedFileType,
      maxFileSize: this.maxFileSize,
      headers: [{ name: 'Authorization', value: 'Bearer ' + this.accountService.getTokenData() }]
    });

    this.uploader.onWhenAddingFileFailed = (item, filter, options) => this.onWhenAddingFileFailed(item, filter, options);
    this.getFacilityTypes();
    this.getProductTypes();
    this.getFacilityList();
    this.getQualifications();
    this.getProfessionalTypes();
    this.getmLevels();
    this.getmRLevels();
    this.getEducationLevels(false);
    this.getOwnershipTypes();
    this.buttonName = 'Next';
    this.tabIndex = 0;
    this.tab = this.tabList[this.tabIndex];
    this.user = this.accountService.getUserData();
    this.documents = [];
    this.documentRefs = [];
    this.selectedFacilityId = parseInt(this.route.snapshot.queryParams.facilityId);
  }

  getProfessionalTypes(): void {
    this.commonService.getProfessionalTypes().subscribe(professionalTypes => {
      this.professionalTypes = professionalTypes;
    });
  }
  
  getOwnershipTypes(): void {
    this.commonService.getOwnershipTypes().subscribe(organizationTypes => this.ownershipTypes = organizationTypes);
  }

  getProductTypes(facilityTypeID = 0): void {
    this.commonService.getProductTypes(facilityTypeID, this.tempCOC).subscribe(productTypes =>{
      this.productTypes = productTypes;
      if (this.tempCOC) {
        this.productTypes = productTypes.filter( pt => pt.name.indexOf('Med') > -1 || 
            pt.name.indexOf(Constants.PROUDCT_TYPE_BARRIER_FACE_MASK) > -1);
      }
    });
  }

  getFacilityTypes(): void {
    this.commonService.getFacilityTypes(true).subscribe(facilityTypes => {
      this.facilityTypes = facilityTypes;
      if (this.tempCOC) {
        this.facilityTypes = facilityTypes.filter(ft =>
          ft.facilityTypeCode === 'IMPR' || ft.facilityTypeCode === 'MNFR' || ft.facilityTypeCode == 'WSLR');
      }
    });
  }

  getmLevels(): void {
    this.commonService.getMLevels().subscribe(mLevels => this.mLevels = mLevels);
  }

  getmRLevels(): void {
    this.commonService.getMRLevels().subscribe(mRLevels => {
        this.mRLevels = mRLevels;
        this.allmRLevels = mRLevels;
      }
    );
  }

  onWhenAddingFileFailed(item: FileLikeObject, filter: any, options: any) {
    switch (filter.name) {
      case 'fileSize':
        this.uploadErrorMessage = `Maximum upload size exceeded ( ${(item.size / (1024 * 1024)).toFixed(1)} MB uploaded,
         ${(this.maxFileSize / (1024 * 1024)).toFixed(1)} MB allowed)`;
        break;
      case 'fileType':
        const allowedTypes = this.allowedFileType.join();
        this.uploadErrorMessage = `Type '${item.type} is not allowed. Allowed types: '${allowedTypes}'`;
        break;
      default:
        this.uploadErrorMessage = `Unknown error (filter is ${filter.name})`;
    }
  }

  getFacilityList() {
    this.facilityService.getFacilitiesForChange(this.tempCOC).subscribe(
      res => {
        if (res) {
          this.facilities = res;
          if (this.applicationId) {
            this.editMode = true;
            this.getApplicationForEditing();
          }
          if (this.selectedFacilityId) {
            this.selectedFacility = this.facilities.filter(facility => facility.id === this.selectedFacilityId)[0];
            this.getProductTypes(this.selectedFacility.facilityTypeID);
            this.facilitySelected(this.editMode);
          }
        } else {
          console.log('Error fetching facilities');
        }
      }, err => {
        console.log('Error fetching facilities ' + err);
        this.alertService.error('Error fetching facilities, ' + this.errorHandlerService.handleApiError(err));
      }
    );
  }

  getFacilityChangeTypes() {
    let productTypeId = this.selectedFacility.productTypeID;
    if(this.editMode && this.applicationDetail){
        this.applicationDetail.newApplicationChangeTypes.forEach(newApplicationChangeType => {
          if(newApplicationChangeType.changeType.changeTypeRef.name == Constants.CHANGE_TYPE_PRODUCT_TYPE_CHANGE){
            let newObj = this.draftMode ? JSON.parse(newApplicationChangeType.newValue) : newApplicationChangeType.newValueObj;
            if(newObj && this.applicationDetail.productTypeID == newObj.productType.id){
              // there is product type change and it is already applied, certificate generated so
              // if we are editing it, this means we are in void FIR, so the change types should be filtered by the old prouct type
              let oldObj = this.draftMode ? JSON.parse(newApplicationChangeType.oldValue) : newApplicationChangeType.oldValueObj
              productTypeId = oldObj.productType.id;
              this.previousProductId = productTypeId;
            }
          }
        });  
    }

    this.facilityService.getFacilityChangeTypesForFacilityAndProductType(this.selectedFacility.facilityTypeID,
      productTypeId, this.tempCOC).subscribe(
        res => {
          if (res) {
            this.changeTypes = [];
            const that = this;
            res.forEach(function (changeType) {
              that.changeTypes.push(changeType);
            });

            let filteredProfessionals = [Constants.HYGIENE_AND_SANITATION_EXPERT_NAME, Constants.PHYSICO_CHEMICAL_EXPERT_Name,
              Constants.MICROBIOLOGIST_Name];
            const manufacturingLevel = that.mLevels.find(m => m.id === that.selectedFacility.mLevelID);
            const mrLevel = that.mRLevels.find(x => x.id === that.selectedFacility.mrLevelID);
            if (that.selectedFacility.facilityTypeID === Constants.MANUFACTURER_ID &&
              that.selectedFacility.productTypeName === Constants.PRODUCT_TYPE_FOOD &&
              manufacturingLevel.mLevelTypeCode === Constants.MANUFACTURING_LEVEL_LOWER &&
              mrLevel.mrLevelTypeCode === Constants.MANUFACTURING_RISK_LEVEL_LOW) {
                that.changeTypes = that.changeTypes.filter(ct => filteredProfessionals.indexOf(ct.changeTypeRef.name) === -1);
              }

            let orgTypeCode = this.selectedFacility.organizationTypeCode || this.selectedFacility.ownershipTypeCode;
            if(orgTypeCode != Constants.PRIVATE){
              // facility name change is allowed only for private facilities
              that.changeTypes = that.changeTypes.filter(ct => ct.changeTypeRef.name != Constants.CHANGE_TYPE_FACILITY_NAME);
            }
            this.getChangeTypes(this.changeTypes);
          } else {
            console.log('Error fetching change types');
          }
        }, err => {
          console.log('Error fetching change types' + err);
        },
        () => {
          this.spinner.hide();
        }
      );
  }

  getChangeTypes(changeTypes) {
    console.log(changeTypes);
    console.log(this.newSelectedChangeTypes);
    changeTypes.forEach(changeType => {
      this.newSelectedChangeTypes.forEach(selectedChangeType => {
        if (changeType.id === selectedChangeType.id) {
          this.checkboxValueChanged(changeType);
        }
      });
    });

    if(this.editMode)
    {
      this.allChangesLoaded = true;
      this.fetchConfiguredProfessionals();
    }
  }

  initializeForm() {
    if (this.selectedAppDetail) {
      this.changeForm = this.fb.group({
        facility: this.fb.group({
          name: [this.selectedAppDetail.facility.name],
          tinNumber: [this.selectedAppDetail.facility.tinNumber],
          specificProductIDs: [this.selectedAppDetail.specificProductIDs],
          specificProductItemIDs: [this.selectedAppDetail.specificProductItemIDs],
          facilityTypeID: [this.selectedAppDetail.facility.facilityTypeID, Validators.required],
          productTypeID: [this.selectedAppDetail.productTypeID, Validators.required],
          ownerName: [this.selectedAppDetail.facility.ownerName, Validators.required],
          ownerPhoneNumber: [this.selectedAppDetail.facility.ownerPhoneNumber, [Validators.required, NumberValidator.isPhoneNumber]],
          organizationTypeID: [this.selectedAppDetail.facility.ownershipTypeID, Validators.required],
        }),
        location: this.fb.group({
          regionID: [this.selectedAppDetail.location.regionID],
          zoneID: [this.selectedAppDetail.location.zoneID],
          subCityID: [this.selectedAppDetail.location.subCityID],
          woredaID: [this.selectedAppDetail.location.woredaID],
          cityID: [this.selectedAppDetail.location.cityID],
          kebele: [this.selectedAppDetail.location.kebele],
          houseNo: [this.selectedAppDetail.location.houseNo],
          phoneNo: [this.selectedAppDetail.location.phoneNo, [NumberValidator.isPhoneNumber]],
          areaName: [this.selectedAppDetail.location.areaName]
        }),
        professionals: this.fb.group({}),
        checklist: this.fb.group({}),
        paymentInfo: this.fb.group({
          receiptNumber: ['', withNoScriptValidators([Validators.required])]
        })
      });
      this.selectedOrganizationName = this.selectedAppDetail.facility.name;
    }
  }

  facilitySelected(editMode) {
    this.documents = [];
    this.checklistInstances = [];
    this.checklists = [];
    this.selectedChangeTypes = [];
    this.professionalsField = [];
    this.basicInfoFields = [];
    this.changeFee = [];
    this.feeSum = 0;
    this.selectedFacility = this.facilities.find(fac => fac.id === this.selectedFacilityId);
    if(!this.selectedFacility.productTypeID){
      this.selectedFacility.productTypeID = this.applicationDetail.productTypeID;
    }
    this.getFacilityChangeTypes();
    if (!editMode) {
      this.getApplicationForSelectedFacility();
    }
    this.tabList = ['changeDetail', 'fileAttachments'];
  }

  getApplicationForSelectedFacility() {
    this.applicationService.getApplication(this.selectedFacility.applicationID).subscribe(data => {
      this.selectedAppDetail = new ApplicationDetail(data, null);
      this.selectedSpecificProductItems = data.facilitySpecificProductItems;
      this.initializeForm();
      this.spItemChange();
      this.changeChoiceReady = true;
    },
      err => {
        this.alertService.error(this.errorHandlerService.handleApiError(err));
      });
  }

  checkboxValueChanged(changeType) {
    changeType.selected = !changeType.selected;
    const changeTypeIndex = this.selectedChangeTypes.indexOf(changeType);
    if (changeTypeIndex === -1) {
      this.selectedChangeTypes.push(changeType);
      this.fetchDocumentsForChange(changeType.changeTypeRefID);
      this.calculateFee(changeType);
      this.changeTabList(changeType, true);
    } else {
      this.selectedChangeTypes.splice(changeTypeIndex, 1);
      this.documentRefs = this.filterChangeDocuments(changeType.changeTypeRefID);
      this.setRestrictedDocRefCount();
      this.removeChangeConfig(changeType.changeTypeRefID);
      this.removeFeeForChange(changeType);
      this.changeTabList(changeType, false);
    }
    if (this.selectedChangeTypes.length === 0) {
      this.showFee = false;
    }

    if (changeType.changeTypeRef.name === Constants.CHANGE_TYPE_PREMISE_MODIFICATION) {
      this.premiseModificationSelected = !this.premiseModificationSelected;
    } else if (changeType.changeTypeRef.name === Constants.CHANGE_TYPE_ADDRESS) {
      this.addressChangeSelected = !this.addressChangeSelected;
    }
  }

  removeChangeConfig(changeTypeRefId) {
    const changeConfigs = this.changeConfigs.filter(cc => cc.changeTypeRefId === changeTypeRefId);
    if (changeConfigs && changeConfigs.length > 0) {
      const index = this.changeConfigs.indexOf(changeConfigs[0]);
      this.changeConfigs.splice(index, 1);
    }
  }

  getDocuments() {
    let docRef = [];
    if (this.changeConfigs.length > 0) {
      for (const changeConfig of this.changeConfigs) {
        for (let i = 0; i < changeConfig.documents.length; i++) {
          const doc = changeConfig.documents[i];
          const d = docRef.filter(dr => dr.id === doc.id);
          if (!d || d.length === 0) {
            docRef.push(doc);
          }
        }
      }
    }
    return docRef;
  }

  filterChangeDocuments(changeTypeRefID) {
    let docRef = [];
    if (this.changeConfigs.length > 0) {
      for (const changeConfig of this.changeConfigs) {
        if (changeConfig.changeTypeRefId === changeTypeRefID) {
          continue;
        }
        for (let i = 0; i < changeConfig.documents.length; i++) {
          const doc = changeConfig.documents[i];
          const d = docRef.filter(dr => dr.id === doc.id);
          if (!d || d.length === 0) {
            docRef.push(doc);
          }
        }
      }
    }
    return docRef;
  }

  fetchAddressLookups() {
    this.commonService.getRegionTypes().subscribe(regionTypes => {
      this.regionList = regionTypes;
    });
    if (this.selectedAppDetail && this.selectedAppDetail.location && this.selectedAppDetail.location.zoneID) {
      if(this.selectedAppDetail.location.subCityID){
        this.showSubCity = true;
        this.commonService.getSubCityTypesByZone(this.selectedAppDetail.location.subCityID).subscribe(subCityTypes => {
          this.subCityList = subCityTypes;
        });
        this.commonService.getWoredaTypesBySubCity(this.selectedAppDetail.location.subCityID).subscribe(woredaTypes => {
          this.woredaList = woredaTypes;
        });
      } else {
        this.showSubCity = false;
        this.commonService.getWoredaTypesByZone(this.selectedAppDetail.location.zoneID).subscribe(woredaTypes => {
          this.woredaList = woredaTypes;
        });
      }
    } else {
      this.commonService.getWoredaTypes().subscribe(woredaTypes => {
        this.woredaList = woredaTypes;
      });
    }

    if (this.selectedAppDetail && this.selectedAppDetail.location && this.selectedAppDetail.location.regionID) {
      this.commonService.getZoneTypesByRegion(this.selectedAppDetail.location.regionID).subscribe(zoneTypes => {
        this.zoneList = zoneTypes;
      });
    } else {
      this.commonService.getZoneTypes().subscribe(zoneTypes => {
        this.zoneList = zoneTypes;
      });
    }
    this.commonService.getCities().subscribe(cities => {
      this.cityList = cities;
    });
  }

  fetchSpecificProducts() {
    const product = this.productTypes.find( x => x.id === this.selectedFacility.productTypeID);
    const facilityType = this.facilityTypes.find(x => x.id === this.selectedFacility.facilityTypeID);
    this.commonService.getFilteredSpecificProducts(this.selectedFacility.facilityTypeID,
      this.selectedFacility.productTypeID).subscribe(specificProducts => {
        this.specificProductList = specificProducts;
        if(product.name == Constants.PRODUCT_TYPE_MEDICINE && facilityType.name == Constants.MANUFACTURER){
          if(this.tempCOC){
            this.specificProductList = this.specificProductList.filter(s => s.name.trim() === Constants.SP_PHARM_MED_CHEMICALS);
          } else {
            this.specificProductList = this.specificProductList.filter(s => s.name.trim() !== Constants.SP_PHARM_MED_CHEMICALS);
          }
        } else if(product.name == Constants.PRODUCT_TYPE_MEDICINE && facilityType.name == Constants.IMPORTER){
          if(this.tempCOC){
            this.specificProductList = this.specificProductList.filter(s => s.name.trim() === Constants.SP_HUMAN_MED_SUPS);
          }
        }
      });
  }

  getEducationLevels(filter: boolean): void {
    this.commonService.getEducationLevels(filter).subscribe(educationLevels => this.educationLevels = educationLevels);
  }

  getQualifications(): void {
    this.commonService.getQualificationTypes().subscribe(qualificationTypes => {
      this.qualificationTypes = qualificationTypes;
    });
  }

  specificProductChanges(editMode) {

    if (!editMode) {
      let allowedSPItems = this.specificProductItems.filter(item => this.changeForm.value.facility.specificProductIDs.indexOf(item.specificProductID) !== -1).map(item => item.id);
      this.changeForm.get('facility').get('specificProductItemIDs').setValue(this.changeForm.value.facility.specificProductItemIDs.filter(item => allowedSPItems.indexOf(item) !== -1));
      this.selectedSpecificProductItems = this.selectedSpecificProductItems.filter(item => allowedSPItems.indexOf(item.specificProductItemID) !== -1);
    }
    this.commonService.getFilteredSpecificProductItems(this.changeForm.value.facility.specificProductIDs)
      .subscribe(specificProductItems => {
        this.specificProductItems = specificProductItems;
        
        let medicineSPItems = [Constants.SP_ITEM_ALCOHOL_BASED_HAND_RUB, Constants.SP_ITEM_DISNFECTANT_SURFACE];
        let medDevSpItems = [Constants.SP_ITEM_APRON, Constants.SP_ITEM_FACE_SHIELDS,Constants.SP_ITEM_GLOVES_NON_STERILE, 
          Constants.SP_ITEM_GLOVES_STERILE, Constants.SP_ITEM_GOOGLES,Constants.SP_ITEM_COVER_GOWN,Constants.SP_ITEM_SHOE_COVER,
          Constants.SP_ITEM_STERILE_MEDICAL_MASK, Constants.SP_ITEM_NON_STERILE_MEDICAL_MASK, Constants.SP_ITEM_RESPIRATOR, Constants.SP_ITEM_LAB_SCREENING_KIT,
          Constants.SP_ITEM_LAB_CONFIRMATION_KIT, Constants.SP_ITEM_RT_PCR_KIT,Constants.SP_ITEM_EXTRACTION_KIT, Constants.SP_ITEM_CARTRIDGES,
          Constants.SP_ITEM_SWAB, Constants.SP_ITEM_PULSE_OXIMETER,Constants.SP_ITEM_CONCENTRATOR, Constants.SP_ITEM_NASAL_OXYGEN_CANNULA,
          Constants.SP_ITEM_VENTILATOR_PATIENT, Constants.SP_ITEM_IR_THERMOMETER,Constants.SP_ITEM_CPAP,Constants.SP_ITEM_SUCTION_PUMP,
          Constants.SP_ITEM_HIGH_FLOW_NASAL_CANNULA, Constants.SP_ITEM_MEDICAL_MASK, Constants.SP_ITEM_COVID_TEST_KIT];
        let medAndMedDevSpItems = medicineSPItems.concat(medDevSpItems);

        if(this.tempCOC){
          const productTypeId = this.changeForm.value.facility.productTypeID;
          const productType = this.productTypes.find(x => x.id === productTypeId);

          if(productType.name == Constants.PRODUCT_TYPE_MEDICINE){
            this.specificProductItems = this.specificProductItems.filter(s => medicineSPItems.indexOf(s.name.trim()) !== -1);
          } else if (productType.name == Constants.PRODUCT_TYPE_MED_DEVICES){
            this.specificProductItems = this.specificProductItems.filter(s => medDevSpItems.indexOf(s.name.trim()) !== -1);
          } else if (productType.name == Constants.PRODUCT_TYPE_MED_AND_MED_DEVICES){
            this.specificProductItems = this.specificProductItems.filter(s => medAndMedDevSpItems.indexOf(s.name) !== -1);
          }
        }else {
           // we don't want to see specific products entered for temp coc to show in normal change
          this.specificProductItems = this.specificProductItems.filter(s => medAndMedDevSpItems.indexOf(s.name.trim()) === -1);
        }

        // remove specific product items whose parent specific product is removed
        let specificProductItemIDs = this.changeForm.value.facility.specificProductItemIDs;
        for (let i = 0; i < specificProductItemIDs.length; i++) {
          if (this.specificProductItems.findIndex(s => s.id === specificProductItemIDs[i]) === -1) {
            specificProductItemIDs.splice(i, 1);
            i--;
          }
        }
        this.changeForm.get('facility').get('specificProductItemIDs').setValue(specificProductItemIDs);
        for (let i = 0; i < this.selectedSpecificProductItems.length; i++) {
          if (this.specificProductItems.findIndex(s => s.id === this.selectedSpecificProductItems[i].specificProductItemID) === -1) {
            this.selectedSpecificProductItems.splice(i, 1);
            i--;
          }
        }
        if(this.specificProductItems.length == 0){
          this.showSpecificProductItem = false;  
          this.changeForm.get('facility').get('specificProductItemIDs').clearValidators();                     
        }else{
          this.showSpecificProductItem = true;
          this.changeForm.get('facility').get('specificProductItemIDs').setValidators([Validators.required]); 
        }
        this.changeForm.get('facility').get('specificProductItemIDs').updateValueAndValidity();
        console.log(this.selectedAppDetail.specificProductItemIDs);
    });

  }

  ownershipChanges() {
    if (!this.changeForm) {
      return;
    }

    const ownershipType = this.ownershipTypes.find(ow => ow.id === this.changeForm.value.facility.organizationTypeID);

    const ownershipChange = this.changeConfigs.find(cc => cc.changeTypeRefId === Constants.CHANGE_REF_TYPE_OWNERSHIP_CHANGE);

    if (!ownershipChange) {
      return;
    }

    if (ownershipType.name !== Constants.PLC) {

        const letterIndex = ownershipChange.documents.findIndex(d => d.name === Constants.PLC_ESTABLISHMENT_DOCUMENT);       
        if (letterIndex !== -1) {
          this.plcEstablishmentDoc = ownershipChange.documents[letterIndex];
          ownershipChange.documents.splice(letterIndex,1);
        }

        const regulationIndex = ownershipChange.documents.findIndex(d => d.name === Constants.PLC_ESTABLISHMENT_REGULATION_DOCUMENT);
        if (regulationIndex !== -1) {

          this.plcRequlationDoc = ownershipChange.documents[letterIndex];

          ownershipChange.documents.splice(regulationIndex, 1);

        }
    } else {
      if (this.plcEstablishmentDoc) {

        this.plcEstablishmentDoc.required = true;

        ownershipChange.documents.push(this.plcEstablishmentDoc);
      }

      if (this.plcRequlationDoc) {

        this.plcRequlationDoc.required = true;

        ownershipChange.documents.push(this.plcRequlationDoc);

      }

    }

    this.documentRefs = this.getDocuments();
    this.setRestrictedDocRefCount();

  }

  getFIRDocumentRefs() {

    if (!this.applicationDetail || !([Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.applicationDetail.applicationStatusCode))) {
      return undefined;
    }

    let editFields: FIRItem[] = JSON.parse(this.applicationDetail.editedFields);


        let groupIndex = editFields.findIndex(item => item.name === 'Documents');

        if (groupIndex === -1) {
          return new FIRItem();
        } else {
          return editFields[groupIndex];
        }
  }

  inputIsDisabled(inputValue, controlGroup, controlName) {
    if (this.applicationDetail) {
      if (this.applicationDetail.isLegacyData && inputValue) {
      return  !(inputValue.value === null || inputValue.value === '' || inputValue.value === undefined ||
          (inputValue.value['length'] !== undefined && inputValue.value.length === 0)) &&
        !inputValue.dirty;
      } else if ([Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.applicationDetail.applicationStatusCode)) {
      
        let editFields: FIRItem[] = JSON.parse(this.applicationDetail.editedFields);

        let groupIndex = editFields.findIndex(item => item.name === controlGroup);

        if (groupIndex === -1) {
          return true;
        }

        return editFields[groupIndex].subItems.findIndex(item => item.name === controlName) === -1;
      }
    }
    return false;
  }

  fieldHighlighted(controlGroup,controlName) {
    return { 'input-highlight': this.applicationDetail && 
        	[Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.applicationDetail.applicationStatusCode) 
      && !this.inputIsDisabled(null,controlGroup,controlName) };
  }

  disableChecklistButtons(){
    return (this.applicationDetail  && this.applicationDetail.applicationCategory.name === Constants.APPLICATION_TYPE_NAME_CHANGE 
      && [Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.applicationDetail.applicationStatusCode));
  }

  setAddressValidator() {
    this.changeForm.get('location').get('regionID').setValidators([Validators.required]);
    this.changeForm.get('location').get('zoneID').setValidators([Validators.required]);
    this.changeForm.get('location').get('woredaID').setValidators([Validators.required]);
    this.changeForm.get('location').get('houseNo').setValidators([Validators.required]);
    this.changeForm.get('location').get('phoneNo').setValidators([Validators.required, NumberValidator.isPhoneNumber]);
    this.changeForm.get('location').get('areaName').setValidators([Validators.required]);
    if(this.showSubCity){
      this.changeForm.get('location').get('subCityID').setValidators([Validators.required]);
    }
  }

  clearAddressValidator() {
    this.changeForm.get('location').get('regionID').clearValidators();
    this.changeForm.get('location').get('regionID').setValue(this.selectedAppDetail.location.regionID);
    this.changeForm.get('location').get('zoneID').clearValidators();
    this.changeForm.get('location').get('zoneID').setValue(this.selectedAppDetail.location.zoneID);
    this.changeForm.get('location').get('subCityID').clearValidators();
    this.changeForm.get('location').get('subCityID').setValue(this.selectedAppDetail.location.subCityID);
    this.changeForm.get('location').get('woredaID').clearValidators();
    this.changeForm.get('location').get('woredaID').setValue(this.selectedAppDetail.location.woredaID);
    this.changeForm.get('location').get('cityID').clearValidators();
    this.changeForm.get('location').get('cityID').setValue(this.selectedAppDetail.location.cityID);
    this.changeForm.get('location').get('houseNo').clearValidators();
    this.changeForm.get('location').get('houseNo').setValue(this.selectedAppDetail.location.houseNo);
    this.changeForm.get('location').get('phoneNo').clearValidators();
    this.changeForm.get('location').get('phoneNo').setValue(this.selectedAppDetail.location.phoneNo);
    this.changeForm.get('location').get('areaName').clearValidators();
    this.changeForm.get('location').get('areaName').setValue(this.selectedAppDetail.location.areaName);
  }

  setNewFieldValues(changeType, applicationChangeType: ApplicationChangeType) {
    // will hold old value only for facility name,ownership changes & tin change
    switch (changeType.changeTypeRef.name) {
      case Constants.CHANGE_TYPE_PRODUCT_TYPE_CHANGE:
        applicationChangeType.newValue = JSON.stringify(this.populateProductTypeObject());
        applicationChangeType.dataType = Constants.DATA_TYPE_PRODUCT_TYPE_CHANGE;
        return applicationChangeType;
      case Constants.CHANGE_TYPE_ADDRESS:
        applicationChangeType.newValue = JSON.stringify(this.populateLocationObject(this.changeForm.value.location));
        applicationChangeType.dataType = Constants.DATA_TYPE_ADDRESS_CHANGE;
        return applicationChangeType;
      case Constants.CHANGE_TYPE_SPECIFIC_PRODUCT_CHANGE_OR_ADDITION:
        applicationChangeType.newValue = JSON.stringify(this.populateSpecificProductObject());
        applicationChangeType.dataType = Constants.DATA_TYPE_ADDITIONAL_PRODUCT;
        return applicationChangeType;
      case Constants.CHANGE_TYPE_PRODUCT_LINE_ADDITION:
        applicationChangeType.dataType = Constants.DATA_TYPE_NONE;
        return applicationChangeType;
      case Constants.CHANGE_TYPE_PREMISE_MODIFICATION:
        applicationChangeType.newValue = this.changeForm.value.location.houseNo;
        applicationChangeType.dataType = Constants.DATA_TYPE_PREMISE_MODIFICATION;
        return applicationChangeType;
      case Constants.HYGIENE_AND_SANITATION_EXPERT_NAME:
      case Constants.STORE_MANAGER_NAME:
      case Constants.QUALITY_ASSURANCE_NAME:
      case Constants.Quality_CONTROL_NAME:
      case Constants.PRODUCTION_MANAGER_NAME:
      case Constants.TECHNICAL_LEADER_NAME:
      case Constants.PHYSICO_CHEMICAL_EXPERT_Name:
      case Constants.MICROBIOLOGIST_Name:
        applicationChangeType.newValue = JSON.stringify(this.populateProfessionalObject(new Professionals(this.changeForm.value.professionals, changeType.code)));
        applicationChangeType.dataType = Constants.DATA_TYPE_PROFESSIONAL_CHANGE;
        return applicationChangeType;
      case Constants.CHANGE_TYPE_FACILITY_NAME:
        applicationChangeType.oldValue = this.selectedAppDetail.facility.name;
        applicationChangeType.newValue = this.changeForm.value.facility.name;
        applicationChangeType.dataType = Constants.DATA_TYPE_FACILITY_NAME_CHANGE;
        return applicationChangeType;
      case Constants.CHANGE_TYPE_OWNERSHIP_CHANGE:
        applicationChangeType.oldValue = JSON.stringify(this.populateOwnershipObject(false));
        applicationChangeType.newValue = JSON.stringify(this.populateOwnershipObject(true));
        applicationChangeType.dataType = Constants.DATA_TYPE_OWNERSHIP_CHANGE;
        return applicationChangeType;
      case Constants.CHANGE_TYPE_TIN:
        applicationChangeType.oldValue = JSON.stringify(this.populateOrganizationObject(false));
        applicationChangeType.newValue = JSON.stringify(this.populateOrganizationObject(true));
        applicationChangeType.dataType = Constants.DATA_TYPE_ORGANIZATION;
        return applicationChangeType;
    }
  }


  populateLocationObject(location) {
    location.region = this.regionList.find(r => r.id === location.regionID);
    location.zone = this.zoneList.find(z => z.id === location.zoneID);
    location.woreda = this.woredaList.find(w => w.id === location.woredaID);
    location.cityModel = this.cityList.find(c => c.id === location.cityID);
    location.subCity = this.subCityList.find(c => c.id === location.subCityID);
    return location;
  }

  populateProfessionalObject(professional) {
    professional.qualification = this.qualificationTypes.find(q => q.id === professional.qualificationID);
    professional.educationLevel = this.educationLevels.find(el => el.id === professional.educationLevelID);
    professional.professionalType = this.professionalTypes.find(p => p.id === professional.professionalTypeID);
    return professional;
  }

  populateSpecificProductObject() {
    let facilitySpecificProducts:any[] = [];
    let facilitySpecificProductItems:any[] = [];

    this.changeForm.value.facility.specificProductIDs.forEach(element => {

      let facilitySP = {
        specificProductID : element,
        specificProduct: this.specificProductList.find(sp => sp.id === element)
      };

      facilitySpecificProducts.push(facilitySP);
    });

    if(!this.showFoodManufacturerMenu){
      this.changeForm.value.facility.specificProductItemIDs.forEach(element => {

        let facilitySPI = {
          specificProductItemID : element,
          specificProductItem: this.specificProductItems.find(spi => spi.id === element)
        };
  
        facilitySpecificProductItems.push(facilitySPI);
      });
    } else {
      this.selectedSpecificProductItems.forEach(element => {

        let facilitySPI = {
          specificProductItemID : element.specificProductItemID,
          specificProductItem: this.specificProductItems.find(spi => spi.id === element.specificProductItemID),
        };
  
        facilitySpecificProductItems.push(facilitySPI);
      });
    }


    let value = {
      facilitySpecificProducts: facilitySpecificProducts,
      facilitySpecificProductItems: facilitySpecificProductItems
    };

    return value;
  }

  populateProductTypeObject() {
    let that = this;
    return Object.assign({productType: that.productTypes.find(pt => pt.id == that.changeForm.value.facility.productTypeID)}, 
      this.populateSpecificProductObject());
  }

  changeTabList(changeType, addChangeType) {
    switch (changeType.changeTypeRef.name) {
      case Constants.CHANGE_TYPE_FACILITY_NAME:
        // this.addControl('name', addChangeType);
        if (addChangeType) {
          this.basicInfoFields.push('facilityName');
          if (this.tabList.indexOf('basicInformation') === -1) {
            this.tabList.splice(1, 0, 'basicInformation');
          }
          this.changeForm.get('facility').get('name').setValidators([Validators.required]);
        } else if (this.tabList.indexOf('basicInformation') > -1 && !addChangeType) {
          this.changeForm.get('facility').get('name').clearValidators();
          this.changeForm.get('facility').get('name').setValue(this.selectedAppDetail.facility.name);
          this.basicInfoFields.splice(this.basicInfoFields.indexOf('facilityName'), 1);
          if (this.basicInfoFields.length === 0) {
            this.tabList.splice(this.tabList.indexOf('basicInformation'), 1);
          }
        }
        break;
      case Constants.CHANGE_TYPE_PRODUCT_TYPE_CHANGE:
        if (addChangeType) {
          this.basicInfoFields.push('productType');
          if (this.tabList.indexOf('basicInformation') === -1) {
            this.tabList.splice(1, 0, 'basicInformation');
          }
          this.changeForm.get('facility').get('productTypeID').setValidators([Validators.required]);
          let prodTypes = [Constants.PRODUCT_TYPE_MEDICINE, Constants.PRODUCT_TYPE_MED_DEVICES, Constants.PRODUCT_TYPE_MED_AND_MED_DEVICES];
          const filteredProdTypes = this.productTypes.filter(pt => prodTypes.indexOf(pt.name) !== -1);
          this.productTypes = filteredProdTypes;
        } else if (this.tabList.indexOf('basicInformation') > -1 && !addChangeType) {
          this.getProductTypes();
          this.changeForm.get('facility').get('productTypeID').clearValidators();
          this.changeForm.get('facility').get('productTypeID').setValue(this.selectedAppDetail.productTypeID);
          this.productTypeChange();
          this.basicInfoFields.splice(this.basicInfoFields.indexOf('productType'), 1);
          if (this.basicInfoFields.length === 0) {
            this.tabList.splice(this.tabList.indexOf('basicInformation'), 1);
          }
        }
        this.handleSpecificProductChange(addChangeType);
        if(this.editMode){
          this.productTypeChange(false);
        }
        break;
      case Constants.CHANGE_TYPE_TIN:
        if(addChangeType){
          this.basicInfoFields.push('tin');
          if (this.tabList.indexOf('basicInformation') === -1) {
            this.tabList.splice(1, 0, 'basicInformation');
          }
          this.changeForm.get('facility').get('tinNumber').setValidators([Validators.required]);
        } else if(this.tabList.indexOf('basicInformation') > -1 && !addChangeType){
          this.changeForm.get('facility').get('tinNumber').clearValidators();
          this.changeForm.get('facility').get('tinNumber').setValue(this.selectedAppDetail.facility.tinNumber);
          this.basicInfoFields.splice(this.basicInfoFields.indexOf('tin'), 1);
          if (this.basicInfoFields.length === 0) {
            this.tabList.splice(this.tabList.indexOf('basicInformation'), 1);
          }
        }// want it to pass through since tin change also include ownership related info change
      case Constants.CHANGE_TYPE_OWNERSHIP_CHANGE:
        if (addChangeType) {
          this.basicInfoFields.push('ownership');
          if (this.tabList.indexOf('basicInformation') === -1) {
            this.tabList.splice(1, 0, 'basicInformation');
          }
          this.changeForm.get('facility').get('ownerName').setValidators([Validators.required]);
          this.changeForm.get('facility').get('ownerPhoneNumber').setValidators([Validators.required, NumberValidator.isPhoneNumber]);
          this.changeForm.get('facility').get('organizationTypeID').setValidators([Validators.required]);
        } else if (this.tabList.indexOf('basicInformation') > -1 && !addChangeType) {
          this.changeForm.get('facility').get('ownerName').clearValidators();
          this.changeForm.get('facility').get('ownerPhoneNumber').clearValidators();
          this.changeForm.get('facility').get('organizationTypeID').clearValidators();
          this.changeForm.get('facility').get('ownerName').setValue(this.selectedAppDetail.facility.ownerName);
          this.changeForm.get('facility').get('ownerPhoneNumber').setValue(this.selectedAppDetail.facility.ownerPhoneNumber);
          this.changeForm.get('facility').get('organizationTypeID').setValue(this.selectedAppDetail.facility.ownershipTypeID);
          this.basicInfoFields.splice(this.basicInfoFields.indexOf('ownership'), 1);
          if (this.basicInfoFields.length === 0) {
            this.tabList.splice(this.tabList.indexOf('basicInformation'), 1);
          }
        }

        break;
      case Constants.CHANGE_TYPE_ADDRESS:
      case Constants.CHANGE_TYPE_PREMISE_MODIFICATION:
        // this.addControl('location', addChangeType);
        if (this.tabList.indexOf('facilityAddress') === -1 && addChangeType) {
          if (!this.editMode || (this.editMode &&
            this.newSelectedChangeTypes.find(n => n.changeTypeRef.name === Constants.CHANGE_TYPE_ADDRESS) === undefined)) {
            this.fetchAddressLookups();
          }
          const index = this.tabList.indexOf('basicInformation') === -1 ? 1 : 2;
          this.tabList.splice(index, 0, 'facilityAddress');
          this.setAddressValidator();
        } else if (this.tabList.indexOf('facilityAddress') > -1 && !addChangeType) {
          this.clearAddressValidator();
          this.tabList.splice(this.tabList.indexOf('facilityAddress'), 1);
        }
        break;
      case Constants.CHANGE_TYPE_SPECIFIC_PRODUCT_CHANGE_OR_ADDITION:
        this.handleSpecificProductChange(addChangeType);
        break;
      case Constants.HYGIENE_AND_SANITATION_EXPERT_NAME:
        changeType.code = Constants.HYGIENE_AND_SANITATION_EXPERT_CODE;
        this.handleProfessionalTabConfiguration(addChangeType, Constants.HYGIENE_AND_SANITATION_EXPERT_CODE);
        break;
      case Constants.STORE_MANAGER_NAME:
        changeType.code = Constants.STORE_MANAGER_CODE;
        this.handleProfessionalTabConfiguration(addChangeType, Constants.STORE_MANAGER_CODE);
        break;
      case Constants.QUALITY_ASSURANCE_NAME:
        changeType.code = Constants.QUALITY_ASSURANCE_CODE;
        this.handleProfessionalTabConfiguration(addChangeType, Constants.QUALITY_ASSURANCE_CODE);
        break;
      case Constants.Quality_CONTROL_NAME:
        changeType.code = Constants.Quality_CONTROL_CODE;
        this.handleProfessionalTabConfiguration(addChangeType, Constants.Quality_CONTROL_CODE);
        break;
      case Constants.PRODUCTION_MANAGER_NAME:
        changeType.code = Constants.PRODUCTION_MANAGER_CODE;
        this.handleProfessionalTabConfiguration(addChangeType, Constants.PRODUCTION_MANAGER_CODE);
        break;
      case Constants.TECHNICAL_LEADER_NAME:
        changeType.code = Constants.TECHNICAL_LEADER_CODE;
        this.handleProfessionalTabConfiguration(addChangeType, Constants.TECHNICAL_LEADER_CODE);
        break;
      case Constants.PHYSICO_CHEMICAL_EXPERT_Name:
        changeType.code = Constants.PHYSICO_CHEMICAL_EXPERT_CODE;
        this.handleProfessionalTabConfiguration(addChangeType, Constants.PHYSICO_CHEMICAL_EXPERT_CODE);
        break;
      case Constants.MICROBIOLOGIST_Name:
        changeType.code = Constants.MICROBIOLOGIST_CODE;
        this.handleProfessionalTabConfiguration(addChangeType, Constants.MICROBIOLOGIST_CODE);
        break;
    }
    this.displayChecklistTab();
  }

  displayChecklistTab() {
    let isThereMajorChangeTypeFlow = false;
    for (const ct of this.selectedChangeTypes) {
      if (ct.changeTypeRef.flowType.flowTypeCode === Constants.APPLICATION_FLOW_TYPE_CODE_MAJOR) {
        isThereMajorChangeTypeFlow = true;
        break;
      }
    }
    if (isThereMajorChangeTypeFlow && this.tabList.indexOf('checklists') === -1) {
      if(!this.tempCOC){
        this.getCheckListConfig(this.selectedFacility.facilityTypeID, this.previousProductId ? this.previousProductId : this.selectedFacility.productTypeID);
        const index = this.tabList.length - 1;
        this.tabList.splice(index, 0, 'checklists');
      }    
    } else if (!isThereMajorChangeTypeFlow && this.tabList.indexOf('checklists') > -1) {
      this.clearChecklistControl();
      this.tabList.splice(this.tabList.indexOf('checklists'), 1);
    }

  }

  clearChecklistControl() {

    const checklistFormGroup = this.changeForm.get('checklist') as FormGroup;
      // Remove Previous Checklist Controls
      Object.keys(checklistFormGroup.controls).forEach(control => {
      checklistFormGroup.removeControl(control);
    });

  }

  createChecklistObject() {
    this.checklistInstances = [];
    let controlArray = Object.keys(this.changeForm.get('checklist')['controls']);

    for (let checklistControl of controlArray) {
      if (this.changeForm.get('checklist').get(checklistControl).value.length) {
        const checklistRefIndex = this.checklists.findIndex(item => item.checklist.id.toString() === checklistControl);
        const newChecklistItem: ChecklistInstance = new ChecklistInstance();
        const checklistValue: CheckListValueModel = new CheckListValueModel();
        checklistValue.valueCode = this.changeForm.get('checklist').get(checklistControl).value.toString().toUpperCase();
        checklistValue.name = this.changeForm.get('checklist').get(checklistControl).value.toString();
        newChecklistItem.checkListValue = checklistValue;
        newChecklistItem.checklistID = this.checklists[checklistRefIndex].checklist.id;
        this.checklistInstances.push(newChecklistItem);
      }
    }
  }

  fetchDocumentsForChange(changeTypeRefId) {
    const selectedFacility: FacilityView = this.facilities.find(fac => fac.id === this.selectedFacilityId);

    this.applicationService.getRequiredDocumentsForChange(selectedFacility.id, changeTypeRefId, this.tempCOC).subscribe(
      res => {
        if (res) {
          // we don't want duplicate documents, like payment doc. so we remove them if they are duplicate
          let currentDocs = this.getDocuments();
          currentDocs.forEach(d => {
            let index = res.findIndex(r => r.id === d.id);
            if (index > -1) res.splice(index, 1);
          });

          const existingChangeConfigs = this.changeConfigs.filter(cc => cc.changeTypeRefId === changeTypeRefId &&
            cc.facilityId === this.selectedFacilityId);
          if (existingChangeConfigs && existingChangeConfigs.length > 0) {
            let cc = existingChangeConfigs[0];
            cc.documents = res;
          } else {
            let changeConfig: ChangeConfig = new ChangeConfig();
            changeConfig.facilityId = this.selectedFacilityId;
            changeConfig.changeTypeRefId = changeTypeRefId;
            changeConfig.documents = res;
            this.changeConfigs.push(changeConfig);
          }

          this.documentRefs = this.getDocuments();
          this.setRestrictedDocRefCount();

          this.ownershipChanges();
        }
      },
      err => {
        console.log('Error trying to fetch required documents for change' + err);
      }
    );
  }

  calculateFee(changeType) {
    const selectedFacility: FacilityView = this.facilities.find(fac => fac.id === this.selectedFacilityId);
    const feeConfig = this.changeFee.find(chgFee => chgFee.changeTypeRefId === changeType.changeTypeRefID);
    if (!feeConfig) {
      this.applicationService.calculateFeeForFacilityChange(selectedFacility.id, changeType.changeTypeRefID, this.tempCOC).subscribe(
        res => {
          if (res) {
            let changeFeeConfig = new ChangeFeeConfig();
            changeFeeConfig.fee = res.fee;
            changeFeeConfig.changeTypeRefId = changeType.changeTypeRefID;
            changeFeeConfig.changeTypeName = changeType.changeTypeRef.name;
            this.changeFee.push(changeFeeConfig);
            this.feeSum += changeFeeConfig.fee;
          }
        },
        err => {
          console.log('Error trying to fetch change fee' + err);
        }
      );
    }
  }

  removeFeeForChange(changeType) {
    const feeConfig = this.changeFee.find(chgFee => chgFee.changeTypeRefId === changeType.changeTypeRefID);
    this.changeFee.splice(this.changeFee.indexOf(feeConfig), 1);
    this.feeSum -= feeConfig.fee;
  }

  showFeeAndDocuments() {
    this.showFee = true;
  }

  activeTab(tab) {
    return this.tab === tab;
  }

  tabShouldShow(tab) {
    return this.tabList.indexOf(tab) > -1;
  }

  tabClicked(tab) {
    this.tab = tab;
    this.tabIndex = this.tabList.indexOf(tab);
    this.setButtonName();
  }

  tabDisabled(tabName) {
    switch (tabName) {
      case 'basicInformation':
        return !this.changeForm || this.nextButtonsShouldBeDisabled();
      case 'facilityAddress':
        return !this.changeForm || this.tabDisabled('basicInformation') || this.changeForm.controls.facility.invalid || (this.showFoodManufacturerMenu && !this.isSpecificProdItemTableValid());
      case 'professionals':
        return !this.changeForm || this.tabDisabled('facilityAddress') || this.changeForm.controls.location.invalid;
      case 'checklists':
        return !this.changeForm || this.tabDisabled('professionals') || this.changeForm.controls.professionals.invalid;
      case 'fileAttachments':
        if (this.tabList.length === 2) {
          return !this.changeForm || !this.selectedFacility || !this.selectedChangeTypes || !(this.selectedChangeTypes.length > 0);
        } else if (this.changeForm && this.tabList.indexOf(tabName) > -1) {
          return !this.changeForm || this.changeForm.controls.professionals.invalid ||  this.changeForm.controls.facility.invalid || (this.checklists.length && (this.tabDisabled('checklists') || this.changeForm.controls.checklist.invalid));
        }
    }
  }

  buttonsShouldBeDisabled() {
    return !this.selectedFacility || !this.selectedChangeTypes || !(this.selectedChangeTypes.length > 0);
  }
  nextButtonsShouldBeDisabled() {
    return this.buttonsShouldBeDisabled() || !this.changeSummary;
  }

  nextClicked() {
    if (this.tabIndex + 1 < this.tabList.length) {
      this.tabIndex++;
      this.tab = this.tabList[this.tabIndex];
      if(this.tab == 'checklists' && this.disableChecklistButtons()){
        this.tabIndex++;
        this.tab = this.tabList[this.tabIndex];
      }
      this.setButtonName();
    } else if (this.tabIndex + 1 === this.tabList.length) {
      this.submitClicked();
    }
  }

  submitButtonDisabled() {
    return this.changeForm.invalid || !this.checkAllRequiredDocsUploaded();
  }

  setButtonName() {
    if (this.tab === 'fileAttachment') {
      this.buttonName = 'Submit';
    } else {
      this.buttonName = 'Next';
    }
  }

  updateHierarchyLists(adminBoundary: any, source: string) {
    if (adminBoundary !== undefined) {
      switch (source) {
        case 'regionID':
          adminBoundary = <RegionType>adminBoundary;
          this.changeForm.controls.location['controls'].zoneID.setValue(null);
          this.changeForm['controls'].location['controls'].woredaID.setValue(null);
          this.sortHierarchy(adminBoundary, source);
          this.woredaList = [];
          break;
        case 'zoneID':
          adminBoundary = <ZoneType>adminBoundary;
          this.showSubCity = adminBoundary.isCity ? true : false;
          if(adminBoundary.isCity){         
            this.changeForm.get('location').get('subCityID').setValidators([Validators.required]);      
          } else {
            this.changeForm.get('location').get('subCityID').clearValidators();
          }
          this.changeForm['controls'].location['controls'].woredaID.setValue(null);
          this.changeForm['controls'].location['controls'].subCityID.setValue(null);
          this.changeForm.get('location').get('subCityID').updateValueAndValidity();
          this.sortHierarchy(adminBoundary, source);
          break;
        case 'subCityID':
          adminBoundary = <ZoneType>adminBoundary;
          this.changeForm['controls'].location['controls'].woredaID.setValue(null);
          this.sortHierarchy(adminBoundary, source);
          break;          
      }
    }
  }

  sortHierarchy = function (adminBoundary, source: string) {
    const _that = this;
    let selectedBoundaryID = adminBoundary !== null ? adminBoundary.id : -1;
    switch (source) {
      case 'regionID':
        _that.commonService.getZoneTypesByRegion(selectedBoundaryID).subscribe(zoneTypes => {
          _that.zoneList = zoneTypes;
        });
        break;
      case 'zoneID':
        if(adminBoundary.isCity){
          _that.commonService.getSubCityTypesByZone(selectedBoundaryID).subscribe(subCityTypes => {
            _that.subCityList = subCityTypes;
          });
        } else {
          _that.commonService.getWoredaTypesByZone(selectedBoundaryID).subscribe(woredaTypes => {
            _that.woredaList = woredaTypes;
          });
        }
        break;
      case 'subCityID':
        _that.commonService.getWoredaTypesBySubCity(selectedBoundaryID).subscribe(woredaTypes => {
          _that.woredaList = woredaTypes;
        });
        break;
      default:
        break;
    }
  };
  
  returnFormValues(item) {
    const checklistFormGroup = this.changeForm.get('checklist') as FormGroup;
    if (this.editMode) {
      const idx = this.applicationDetail.checkListItems.findIndex(it => { return item.checklistID === it.checklistID; });
      if (idx > -1) {
        return this.applicationDetail.checkListItems[idx].checkListValue.name;
      }
    }
    return checklistFormGroup.get(item.checklist.id.toString()) ? checklistFormGroup.get(item.checklist.id.toString()).value : '';
  }

  getCheckListConfig(facilityType, productTypeId) {
    const checklistFormGroup = this.changeForm.get('checklist') as FormGroup;
    // Remove Previous Checklist Controls
    Object.keys(checklistFormGroup.controls).forEach(control => {
      checklistFormGroup.removeControl(control);
    });
    const changeTypeRef = {
      facilityTypeID: facilityType,
      productTypeID: productTypeId,
      changeTypeRefIDs: this.selectedChangeTypes.map(items => items.changeTypeRef.id)
    };
    this.settingsService.getChangeChecklistConfigForFacilityTypeProductTypeAppCategoryFacilityCategoryAndChangeType(changeTypeRef)
      .subscribe(
        res => {
          let itemValue;
          if (res.length) {
            this.checklists = res.filter(c => c.active);
            this.checklists.forEach(item => {
              itemValue = this.returnFormValues(item);
              if (item.required) {
                checklistFormGroup.addControl(item.checklist.id.toString(), new FormControl(itemValue, [Validators.required]));
              } else {
                checklistFormGroup.addControl(item.checklist.id.toString(), new FormControl(itemValue));
              }
            });

            this.noChecklistAvailable = !this.checklists.length;

          } else {
            this.noChecklistAvailable = true;
          }
        }
      );
  }

  retrievePaymentDetail(detail) {
    this.paymentInfo = detail;
    console.log('payment detail ', detail);
  }

  /**
   * CreateApplicationAsync requires PaymentInfo.Payment (ServiceProvider) to mint a bill.
   * File-upload only emits receipt + documentID; change drafts historically omit payment method.
   */
  private ensurePaymentPayload(): void {
    const receipt = this.changeForm?.get('paymentInfo')?.get('receiptNumber')?.value;
    if (!this.paymentInfo) {
      this.paymentInfo = new PaymentInfo({ recieptNumber: receipt });
    }
    if (receipt) {
      this.paymentInfo.recieptNumber = receipt;
    }
    const existing = this.paymentInfo.payment || {};
    const provider = existing.ServiceProvider || existing.serviceProvider || 'CASH';
    this.paymentInfo.payment = Object.assign({}, existing, { ServiceProvider: provider });
  }

  private discardDraftIfNeeded(): void {
    const draftId = this.draftApplicationId
      || (this.applicationDetail && this.applicationDetail['draftID']);
    if (!this.draftMode || !draftId) {
      return;
    }
    this.applicationService.deleteDraftApplication(draftId).subscribe(() => {
      console.log('Draft version of the application has been removed');
    }, () => {
      console.log('Unable to remove the draft version of the application');
      this.alertService.error('Unable to remove the draft version of the application');
    });
  }

  createApplicationChangeTypes(saveDraft) {
    let newApplicationChangeTypes: ApplicationChangeType[] = [];
    const that = this;
    this.selectedChangeTypes.forEach(function (changeType) {
      let newApplicationChangeType = new ApplicationChangeType();
      newApplicationChangeType.changeTypeID = changeType.id;
      if (saveDraft) {

        newApplicationChangeType.changeType = that.changeTypes.find(ct => ct.id === changeType.id);

      }

      let oldValue = null;
      if (that.editMode && that.applicationDetail && that.applicationDetail.newApplicationChangeTypes.length > 0) {
        newApplicationChangeType.oldApplicationID = that.applicationDetail.newApplicationChangeTypes[0].oldApplicationID;
        
        //TODO: find a way to identify if the application is being edited after voiding
        // that.applicationDetail.licenseDate && that.applicationDetail.licenseNumber can't be used anymore
        /*if(that.applicationDetail.licenseDate && that.applicationDetail.licenseNumber){
          // if we are doing VOID FIR we don't want the old values to be overwritten
         let appChangeType = that.applicationDetail.newApplicationChangeTypes.find(a => a.changeTypeID == changeType.id);
         oldValue = appChangeType.oldValue;
        }*/
        
      } else {
        newApplicationChangeType.oldApplicationID = that.selectedFacility.applicationID;
      }

      newApplicationChangeType = that.setNewFieldValues(changeType, newApplicationChangeType);
      newApplicationChangeTypes.push(newApplicationChangeType);

    });
    this.newApplicationChangeTypes = newApplicationChangeTypes;

  }

  legacyDataRequiresEditing() {
    return this.selectedFacility && this.selectedFacility.isLegacyData &&
      this.selectedFacility.applicationStatusCode !== Constants.LEGACY_DATA_EDITED_CODE;
  }

  editSelectedFacility(selectedFacility) {
    this.router.navigate(['/edit/' + selectedFacility.applicationID], { queryParams: { ldeType: Constants.APPLICATION_TYPE_CODE_CHANGE } });
  }

  submitClicked() {
    this.spinner.show();
    this.createChecklistObject();
    this.createApplicationChangeTypes(false);
    this.ensurePaymentPayload();
    // Draft mode clears applicationId so submit must create, not edit.
    const useEditPath = this.editMode && (!this.draftMode || this.applicationId);
    if (useEditPath) {

      this.applicationDetail.documents = this.documents;
      this.applicationDetail.checkListInstances = this.checklistInstances;
      this.applicationDetail.paymentInfos = [this.paymentInfo];
      this.applicationDetail.changeSummary = this.changeSummary;
      const changeApplicationForEditing: ChangeApplication = new ChangeApplication(this.selectedAppDetail, this.applicationId, this.documents,
        this.checklistInstances, this.paymentInfo, this.newApplicationChangeTypes, this.changeSummary);
      console.log(changeApplicationForEditing)
      this.applicationService.editApplicationChange(changeApplicationForEditing, this.tempCOC).subscribe(
        res => {
          this.spinner.hide();
          if (res) {
            this.alertService.success('Successfully submitted application');
            this.discardDraftIfNeeded();
            this.router.navigateByUrl('/applications/list/' + this.applicationDetail.id);
          } else {
            this.alertService.error('Unable to edit application. Please try again later');
          }
        },
        err => {
          this.alertService.error('Unable to edit application, ' + this.errorHandlerService.handleApiError(err));
          this.spinner.hide();
        }
      );
    } else {
      const changeApplication: ChangeApplication = new ChangeApplication(this.selectedAppDetail, null, this.documents,
        this.checklistInstances, this.paymentInfo, this.newApplicationChangeTypes, this.changeSummary);
      this.applicationService.submitApplicationChange(changeApplication, this.tempCOC).subscribe(
        res => {
          this.spinner.hide();
          if (res) {
            this.alertService.success('Successfully submitted application');
            this.discardDraftIfNeeded();
            this.router.navigateByUrl('/applications/list/' + res.id);
          } else {
            this.alertService.error('Unable to edit application. Please try again later');
          }
        },
        err => {
          this.alertService.error(this.errorHandlerService.handleApiError(err));
          this.spinner.hide();
        }
      );
    }
  }

  selectedNameChangeOrPremiseModification(name) {
    return (name == Constants.CHANGE_TYPE_PREMISE_MODIFICATION && this.selectedChangeTypes.findIndex(s => s.changeTypeRef.name == Constants.CHANGE_TYPE_ADDRESS) !== -1) ||
     (name == Constants.CHANGE_TYPE_ADDRESS && this.selectedChangeTypes.findIndex(s => s.changeTypeRef.name == Constants.CHANGE_TYPE_PREMISE_MODIFICATION) !== -1) ||
     ((name == Constants.CHANGE_TYPE_PRODUCT_TYPE_CHANGE && this.selectedChangeTypes.findIndex(s => s.changeTypeRef.name == Constants.CHANGE_TYPE_SPECIFIC_PRODUCT_CHANGE_OR_ADDITION) !== -1)) ||
     ((name == Constants.CHANGE_TYPE_SPECIFIC_PRODUCT_CHANGE_OR_ADDITION && this.selectedChangeTypes.findIndex(s => s.changeTypeRef.name == Constants.CHANGE_TYPE_PRODUCT_TYPE_CHANGE) !== -1)) ||
     ((this.professionalChanges.indexOf(name) > -1 && this.selectedChangeTypes.findIndex(s => s.changeTypeRef.name == Constants.CHANGE_TYPE_PRODUCT_TYPE_CHANGE) !== -1)) ||
     ((name == Constants.CHANGE_TYPE_PRODUCT_TYPE_CHANGE && this.selectedChangeTypes.findIndex(s => this.professionalChanges.indexOf(s.changeTypeRef.name) > -1) !== -1)) ||
     ((name == Constants.CHANGE_TYPE_FACILITY_NAME || name == Constants.CHANGE_TYPE_OWNERSHIP_CHANGE) && this.selectedChangeTypes.findIndex(s => s.changeTypeRef.name == Constants.CHANGE_TYPE_TIN) !== -1) ||
     (name == Constants.CHANGE_TYPE_TIN && this.selectedChangeTypes.findIndex(s => s.changeTypeRef.name == Constants.CHANGE_TYPE_FACILITY_NAME || s.changeTypeRef.name == Constants.CHANGE_TYPE_OWNERSHIP_CHANGE) != -1);
  }

  handleProfessionalTabConfiguration(addChangeType, code) {
    // during edit/draft we want to load professional config data after all change types are loaded
    if(!this.editMode || this.allChangesLoaded)
    {
      this.fetchConfiguredProfessionals();
    }
    
    if (addChangeType) {
      if (this.professionalsField.indexOf(code) === -1) {
        this.professionalsField.push(code);
      }

      if (this.tabList.indexOf('professionals') === -1) {
        
        const index = this.tabList.indexOf('basicInformation') === -1 && this.tabList.indexOf('facilityAddress') === -1 ? 1 :
          (this.tabList.indexOf('basicInformation') === -1 && this.tabList.indexOf('facilityAddress') > -1) ||
            (this.tabList.indexOf('basicInformation') > -1 && this.tabList.indexOf('facilityAddress') === -1) ? 2 : 3;
        this.tabList.splice(index, 0, 'professionals');
      }
    } else if (this.tabList.indexOf('professionals') > -1 && !addChangeType) {
      this.professionalsField.splice(this.professionalsField.indexOf(code), 1);
      if (this.professionalsField.length === 0) {
        this.tabList.splice(this.tabList.indexOf('professionals'), 1);
      }
    }
  }

  saveChangeApplication() {
    this.spinner.show();
    this.createChecklistObject();
    this.createApplicationChangeTypes(true);
    this.ensurePaymentPayload();

    const changeApplicationDraft = new ChangeApplication(this.selectedAppDetail, this.applicationDetail ? this.applicationDetail.id : null, this.documents,
      this.checklistInstances, this.paymentInfo, this.newApplicationChangeTypes, this.changeSummary);

    this.changeDraft = new ChangeDraftApplicationModel(JSON.stringify(changeApplicationDraft), this.erisLoginService.getUserId());
    this.changeDraft.applicationCatagoryID = this.tempCOC ? 9 : 3;

    if (this.editMode) {
      this.changeDraft['id'] = this.applicationDetail['draftID'];
      this.changeDraft['applicationNumber'] = this.applicationDetail['applicationNumber'];
    }

    this.applicationService.saveDraftApplication(this.changeDraft).subscribe(res => {
      this.spinner.hide();
      if (res) {
        this.alertService.success('Successfully saved change application');
        this.router.navigateByUrl('/applications/all');

      } else {
        this.alertService.error('Unable to save draft for application. Please try again later');
      }
    }, error => {
      this.spinner.hide();
      this.alertService.error(this.errorHandlerService.handleApiError(error));
     })
  }

  getApplicationForEditing() {
    if (this.draftMode) {
      this.draftApplicationId = this.applicationId;
      this.applicationId = null;
      this.applicationService.getDraftApplication(this.draftApplicationId).subscribe(
        res => {
          console.log(res.applicationJsonData);
          this.allChangesLoaded = false;
          let draftApplication: ChangeDraftDetail = new ChangeDraftDetail(res);
          //TODO: fix change draft
          this.selectedAppDetail = new ApplicationDetail(draftApplication, null);
          this.selectedAppDetail.mLevelID = draftApplication.mLevelID;
          this.selectedAppDetail.mrLevelID = draftApplication.mrLevelID;
          this.selectedAppDetail.professionals = draftApplication.professionals;
          this.selectedAppDetail.facility.ownershipTypeID = draftApplication.facility.ownershipTypeID;
          this.selectedAppDetail.specificProductIDs = draftApplication.specificProductIDs;
          this.selectedAppDetail.specificProductItemIDs = draftApplication.specificProductItemIDs;
          this.selectedSpecificProductItems = draftApplication.facilitySpecificProductItems;
          this.getProductTypes(this.selectedAppDetail.facility.facilityTypeID);
          this.setChangeApplicationVals(draftApplication)
          this.initializeForm();
          this.changeChoiceReady = true;
          let newApplicationChangeTypes = draftApplication.newApplicationChangeTypes;
          if (newApplicationChangeTypes) {
            this.initializeEditForm(newApplicationChangeTypes, true);
          }

        },
        err => {
          this.alertService.error('Unable to fetch draft application for editing. Please try again later.');
        }
      );
    } else {
      this.applicationService.getApplication(this.applicationId).subscribe(
        res => {
          this.allChangesLoaded = false;
          this.applicationDetail = new ApplicationDetail(res, null);
          this.getProductTypes(this.applicationDetail.facility.facilityTypeID);
          this.selectedAppDetail = new ApplicationDetail(res, null);
          this.selectedSpecificProductItems = res.facilitySpecificProductItems;
          this.setChangeApplicationVals(this.applicationDetail);
          this.initializeForm();
          this.changeChoiceReady = true;
          let newApplicationChangeTypes = this.applicationDetail.newApplicationChangeTypes;
          if (newApplicationChangeTypes) {
            this.initializeEditForm(newApplicationChangeTypes, false);
          }     
        },
        err => {
          this.alertService.error('Unable to fetch application for editing. Please try again later.');
        }
      );
    }

  }

  setChangeApplicationVals(application) {
    this.applicationDetail = application;
    this.facilities = this.facilities.concat(application.facility)
    this.changeSummary = application.changeSummary;
    this.editDocuments = application.documents;
    this.selectedFacility = application.facility;
    this.selectedFacilityId = application.facility.id;
    //this.selectedFacility = this.facilities.filter(facility => facility.id === this.selectedFacilityId)[0];
    // Drafts have no real application id — keep null so submit uses create, not edit.
    this.applicationId = this.draftMode ? null : application.id;
    const paymentInfo: PaymentInfoDetail = application.paymentInfos ? 
        (application.paymentInfos.length ? application.paymentInfos[application.paymentInfos.length - 1] : new PaymentInfoDetail({})) : new PaymentInfoDetail({});
    this.paymentInfo = paymentInfo.recieptNumber || paymentInfo.documentID ? new PaymentInfo(paymentInfo) : null;
    this.newSelectedChangeTypes = []
    application.newApplicationChangeTypes.forEach(NewApplicationChangeType => {
      this.newSelectedChangeTypes.push(NewApplicationChangeType.changeType)
    });

    [Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.applicationDetail.applicationStatusCode) ? this.FIStatus = true : this.FIStatus = false
    this.facilitySelected(this.editMode);

  }

  repopulateZoneAndWoredaList(regionID: number, zoneID: number, subCityID: number) {
    this.commonService.getRegionTypes().subscribe(regionTypes => {
      this.regionList = regionTypes;
    });

    this.commonService.getZoneTypesByRegion(regionID).subscribe(zoneTypes => {
      this.zoneList = zoneTypes;
    });

    if(subCityID){
      this.commonService.getSubCityTypesByZone(zoneID).subscribe(subCityTypes => {
        this.subCityList = subCityTypes;
      });
      this.commonService.getWoredaTypesBySubCity(subCityID).subscribe(woredaTypes => {
        this.woredaList = woredaTypes;
      });
      this.showSubCity = true;
    } else {
      this.commonService.getWoredaTypesByZone(zoneID).subscribe(woredaTypes => {
        this.woredaList = woredaTypes;
      });
    }
  }

  initializeEditForm(newApplicationChangeTypes, isDraft) {
    let newValue: any;
    this.changeForm.get('paymentInfo').get('receiptNumber').setValue(this.paymentInfo ? this.paymentInfo.recieptNumber : null);
    newApplicationChangeTypes.forEach(NewApplicationChangeType => {
      
      if (this.draftMode && NewApplicationChangeType.dataType && NewApplicationChangeType.dataType != Constants.DATA_TYPE_FACILITY_NAME_CHANGE &&
        NewApplicationChangeType.dataType != Constants.DATA_TYPE_PREMISE_MODIFICATION && NewApplicationChangeType.dataType != 
        Constants.DATA_TYPE_NONE) {
        newValue = JSON.parse(NewApplicationChangeType.newValue);
      } else{
        newValue = NewApplicationChangeType.newValueObj;
      }

      if(isDraft){
        switch (NewApplicationChangeType.changeType.changeTypeRef.name) {
          case Constants.CHANGE_TYPE_ADDRESS:
            this.changeForm.get('location').get('regionID').setValue(newValue.regionID);
            this.changeForm.get('location').get('zoneID').setValue(newValue.zoneID);
            this.changeForm.get('location').get('woredaID').setValue(newValue.woredaID);
            this.changeForm.get('location').get('subCityID').setValue(newValue.subCityID);
            this.changeForm.get('location').get('kebele').setValue(newValue.kebele);
            this.changeForm.get('location').get('cityID').setValue(newValue.cityID);
            this.changeForm.get('location').get('houseNo').setValue(newValue.houseNo);
            this.changeForm.get('location').get('phoneNo').setValue(newValue.phoneNo);
            this.changeForm.get('location').get('areaName').setValue(newValue.areaName);                    
            break;
  
          case Constants.CHANGE_TYPE_PRODUCT_TYPE_CHANGE:
              this.changeForm.get('facility').get('productTypeID').setValue(newValue.productType.id);
              // we won't break, let it slide
          case Constants.CHANGE_TYPE_SPECIFIC_PRODUCT_CHANGE_OR_ADDITION:
            let facilitySpecificProducts = newValue.facilitySpecificProducts
            let facilitySpecificProductItems = newValue.facilitySpecificProductItems
            if (facilitySpecificProducts) {
              let specificProductIDs = facilitySpecificProducts.map(sp => sp.specificProductID);
              this.changeForm.get('facility').get('specificProductIDs').setValue(specificProductIDs);
            }
            if (facilitySpecificProductItems) {
              let specificProductItemIDs = facilitySpecificProductItems.map(sp => sp.specificProductItemID);
              this.changeForm.get('facility').get('specificProductItemIDs').setValue(specificProductItemIDs);
              this.selectedSpecificProductItems = facilitySpecificProductItems;
            }                      
            break;      
          case Constants.CHANGE_TYPE_PREMISE_MODIFICATION:
            
            const val = NewApplicationChangeType.newValue;
            this.changeForm.get('location').get('houseNo').setValue(val);
            break;
        }
      }

      switch (NewApplicationChangeType.changeType.changeTypeRef.name) {
        case Constants.CHANGE_TYPE_FACILITY_NAME:
          const value = NewApplicationChangeType.newValue;
          this.changeForm.get('facility').get('name').setValue(value);         
          break;
        case Constants.CHANGE_TYPE_TIN:
          this.selectedOrganizationName = newValue.name;
          this.changeForm.get('facility').get('tinNumber').setValue(newValue.tinNumber);// pass it to the next
        case Constants.CHANGE_TYPE_OWNERSHIP_CHANGE:
          this.changeForm.get('facility').get('ownerName').setValue(newValue.ownerName);
          this.changeForm.get('facility').get('ownerPhoneNumber').setValue(newValue.ownerPhone);
          this.changeForm.get('facility').get('organizationTypeID').setValue(newValue.organizationTypeID);
          this.ownershipChanges();
          break;
      }

      if(NewApplicationChangeType.changeType.changeTypeRef.name == Constants.CHANGE_TYPE_ADDRESS){
        this.repopulateZoneAndWoredaList(newValue.regionID,newValue.zoneID, newValue.subCityID);
      }else if(NewApplicationChangeType.changeType.changeTypeRef.name == Constants.CHANGE_TYPE_PREMISE_MODIFICATION){
        this.fetchAddressLookups();
      }

    });
  }

  checkAllRequiredDocsUploaded() {
    let reqDocumentsCount = 0;
    this.documents.forEach(element => {
      if (element.referenceID != null) {
       let index =  this.documentRefs.findIndex(dr => dr.id === element.referenceID);
       if (index !== -1) {
          this.documentRefs[index].required ? reqDocumentsCount ++ : null;
       }
      }
    });

    // if Medicine, Medical Device or Medicine and Medical Device is selected as a product type
    // and Pharmascist is selected for Store Manager qualification
    // the 'Experience Letter for Store Manager' document will be Optional
    const product = this.productTypes.find(p => p.id === this.changeForm.value.facility.productTypeID);
    if (!this.tempCOC && product !== undefined && [Constants.PRODUCT_TYPE_MEDICINE, Constants.PRODUCT_TYPE_MED_DEVICES,
    Constants.PRODUCT_TYPE_MED_AND_MED_DEVICES].indexOf(product.name) !== -1) {
      const smConfig = this.professionalTypeConfigList.find(pc => pc.professionalType.professionalTypeCode === Constants.STORE_MANAGER_CODE);
      if(smConfig){
        const eduConfig = smConfig.educationLevelConfig.find(ec => ec.educationLevelID == this.changeForm.value.professionals.smEducationLevelID);
        const quaConfig = eduConfig.qualificationConfig.find(qc => qc.qualificationID === this.changeForm.value.professionals.smQualificationID);
        if (quaConfig !== undefined && quaConfig.qualification.name === Constants.PHARMACIST) {
          const docRef = this.documentRefs.find(d => d.name === Constants.EXPERIENCE_LETTER_STORE_MANAGER_DOC);
          if (docRef !== undefined && docRef.required) {
            return this.documents.length >= (this.restrictedDocRefCount - 1);
          }
        }
      }
    }
    return reqDocumentsCount >= this.restrictedDocRefCount;
  }

  setRestrictedDocRefCount() {
    const restrictedDocs = this.documentRefs.filter(function (x) {
      return x.required === true;
    });

    this.restrictedDocRefCount = restrictedDocs.length;
  }

  spItemRemoved() {
    let allowedSPs = [];
    if(!this.showFoodManufacturerMenu){
      allowedSPs = this.specificProductItems.filter(item => this.changeForm.value.facility.specificProductItemIDs.includes(item.id)).map(item => item.specificProductID);
    } else{
      allowedSPs = this.specificProductItems.filter(item => this.selectedSpecificProductItems.findIndex(fspi => fspi.specificProductItemID == item.id) !== -1).map(item => item.specificProductID);
    }
    this.changeForm.get('facility').get('specificProductIDs').setValue(this.changeForm.value.facility.specificProductIDs.filter(item => allowedSPs.indexOf(item) !== -1));
  }

  spItemChange() {
    const selectedFacilityType = this.changeForm.value.facility.facilityTypeID;
    const productTypeId = this.changeForm.value.facility.productTypeID;
    if (productTypeId && productTypeId !== '' && selectedFacilityType && selectedFacilityType !== '') {

      const product = this.productTypes.find(function (x) {
        return x.id === productTypeId;
      });
      }
  }

  fetchConfiguredProfessionals() {
    this.professionalTypeConfigList = [];
    let professionalConfigFilter = new ProfessionalConfigFilter();
    professionalConfigFilter.applicationCategoryID = 3; // id for change application
    if (this.tempCOC) {
      professionalConfigFilter.applicationCategoryID = 9; // id for TCC change
    }
    professionalConfigFilter.facilityTypeID = this.changeForm.value.facility.facilityTypeID;
    professionalConfigFilter.productTypeID = this.changeForm.value.facility.productTypeID;

    const product = this.productTypes.find(p => p.id === this.changeForm.value.facility.productTypeID);
    if (product && [Constants.PRODUCT_TYPE_FOOD, Constants.PRODUCT_TYPE_COSMETICS].indexOf(product.name) !== -1) {
      // we dont want other manufacturers to send this values      
      // cosmetics manufacturers don't have manufacturing risk level value so will not affect anything
      professionalConfigFilter.manufacturingRiskLevelID = this.selectedAppDetail.mrLevelID;
      professionalConfigFilter.manufacturingLevelID = this.selectedAppDetail.mLevelID;
    }
    
    if (this.changeForm.value.facility.specificProductItemIDs &&
      this.changeForm.value.facility.specificProductItemIDs.length > 0) {
      professionalConfigFilter.specificProductItemIDs = this.changeForm.value.facility.specificProductItemIDs;
    }

    if(this.showFoodManufacturerMenu && this.selectedSpecificProductItems.length > 0){
      professionalConfigFilter.specificProductItemIDs = this.selectedSpecificProductItems.map(s => s.specificProductItemID);
    }
    
    professionalConfigFilter.changeTypeRefIDs = this.selectedChangeTypes.map(ct => ct.changeTypeRefID);

    this.settingsService.getProfessionalConfigListForApplicant(professionalConfigFilter).subscribe( res => {
      this.professionalTypeConfigList = res;
      this.createProfessionalForm();
      this.currentProfessionals = this.professionalTypeConfigList.map(pc => pc.professionalType.professionalTypeCode);
    }, err => {

    }, () => {

    });
  }

  createProfessionalForm() {
    Object.keys((this.changeForm.get('professionals') as FormGroup).controls).forEach(key => {
      this.changeForm.get('professionals').get(key).clearValidators();
      this.changeForm.get('professionals').get(key).updateValueAndValidity();
    });

    if (!this.editMode) {
      const allProfessionals = this.selectedAppDetail.professionals[0];

      this.professionalTypeConfigList.forEach(profConfig => {
        profConfig.professionalFieldConfig.filter(pfc => pfc.active).forEach( pf => {

          // when an additional professional change type is selected, we don't want the data filled for another
          // already selected professional change to be overwritten 
          if(this.currentProfessionals.findIndex(pc => pc == profConfig.professionalType.professionalTypeCode) === -1)
          {
            this.fieldValue = allProfessionals[this.formatControlName(profConfig, pf)];
            let fieldValueExistsInLookup = true;

            if (pf.professionalField.professionalFieldCode === Constants.EDUCATION_LEVEL_CODE) {
              fieldValueExistsInLookup = Boolean(profConfig.educationLevelConfig.find(elc => elc.educationLevelID === this.fieldValue));
            }

            (this.changeForm.get('professionals') as FormGroup).addControl(
              this.formatControlName(profConfig, pf),
              new FormControl(fieldValueExistsInLookup ? this.fieldValue : null, null));
          }
          
          if (pf.required) {

            (this.changeForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
              .setValidators(Validators.required);


              if (pf.professionalField.dataType === 'phoneNumber') {
                (this.changeForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                  .setValidators([NumberValidator.isPhoneNumber, Validators.required]);
    
              } else if (pf.professionalField.dataType === 'email') {
                (this.changeForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                  .setValidators([Validators.email, Validators.required]);
              }
              
              if (pf.professionalField.name === Constants.EXPERIENCE_LABEL) {
                (this.changeForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                  .setValidators([Validators.min(0), Validators.required]);
              }

          } else {

            if (pf.professionalField.dataType === 'phoneNumber') {
              (this.changeForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                .setValidators(NumberValidator.isPhoneNumber);
  
            } else if (pf.professionalField.dataType === 'email') {
              (this.changeForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                .setValidators(Validators.email);
            }
            
            if (pf.professionalField.name === Constants.EXPERIENCE_LABEL) {
              (this.changeForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                .setValidators(Validators.min(0));
            }
          }

        });
      });
    } else {

      let allProfessionals = Object.assign({}, this.applicationDetail.professionals[0]);
      if(this.draftMode){
        this.setProfessionalDataFromApplicationChangeType(allProfessionals);
      }
      
      this.professionalTypeConfigList.forEach(profConfig => {
        profConfig.professionalFieldConfig.filter(pfc => pfc.active).forEach( pf => {

          this.fieldValue = allProfessionals[this.formatControlName(profConfig, pf)];
          let fieldValueExistsInLookup = true;

          if (pf.professionalField.professionalFieldCode === Constants.EDUCATION_LEVEL_CODE) {
            fieldValueExistsInLookup = Boolean(profConfig.educationLevelConfig.find(elc => elc.educationLevelID === this.fieldValue));
          }

          (this.changeForm.get('professionals') as FormGroup).addControl(
            this.formatControlName(profConfig, pf),
            new FormControl(fieldValueExistsInLookup ? this.fieldValue : null, null));

          if (pf.required) {

              (this.changeForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                .setValidators(Validators.required);
  
  
                if (pf.professionalField.dataType === 'phoneNumber') {
                  (this.changeForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                    .setValidators([NumberValidator.isPhoneNumber, Validators.required]);
      
                } else if (pf.professionalField.dataType === 'email') {
                  (this.changeForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                    .setValidators([Validators.email, Validators.required]);
                }
                
                if (pf.professionalField.name === Constants.EXPERIENCE_LABEL) {
                  (this.changeForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                    .setValidators([Validators.min(0), Validators.required]);
                }
  
          } else {
  
              if (pf.professionalField.dataType === 'phoneNumber') {
                (this.changeForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                  .setValidators(NumberValidator.isPhoneNumber);
    
              } else if (pf.professionalField.dataType === 'email') {
                (this.changeForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                  .setValidators(Validators.email);
              }
              
              if (pf.professionalField.name === Constants.EXPERIENCE_LABEL) {
                (this.changeForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                  .setValidators(Validators.min(0));
              }
          }  

        });
      });
    }
  }

  formatControlName(profTypeConfig, field) {
    return profTypeConfig.professionalType.professionalTypeCode.toLowerCase() + field.professionalField.name.replace(/ /g, '')
      + (field.professionalField.dataType === 'lookup' ? 'ID' : '');
  }

  onStoreManagerQualificationChange(pharmacistSelected: boolean) {
    if (pharmacistSelected) {
      const product = this.productTypes.find(p => p.id === this.changeForm.value.facility.productTypeID);
      if ([Constants.PRODUCT_TYPE_MEDICINE, Constants.PRODUCT_TYPE_MED_DEVICES,
      Constants.PRODUCT_TYPE_MED_AND_MED_DEVICES].indexOf(product.name) !== -1) {
        this.smLetterOfExperienceDocRequired = false;
      }
    } else {
      this.smLetterOfExperienceDocRequired = true;
    }
  }

  onDiplomaSelection(data: DiplomaSelection) {
    const product = this.productTypes.find(p => p.id === this.changeForm.value.facility.productTypeID);
    const facility = this.facilityTypes.find(f => f.id === this.changeForm.value.facility.facilityTypeID);

    if (product.name !== Constants.PRODUCT_TYPE_FOOD || facility.name !== Constants.MANUFACTURER) {
      return;
    }

    let index = -1;

    switch(data.educationLevelInput)
    {
      case 'pmEducationLevelID':
        index = this.documentRefs.findIndex(d => d.name === Constants.PM_EXPERIENCE_DOCUMENT);
        break;
      case 'qaEducationLevelID':
        index = this.documentRefs.findIndex(d => d.name === Constants.QA_EXPERIENCE_DOCUMENT);
        break;
      case 'hseEducationLevelID':
        index = this.documentRefs.findIndex(d => d.name === Constants.HS_EXPERIENCE_DOCUMENT);
        break;
      case 'pceEducationLevelID':
        index = this.documentRefs.findIndex(d => d.name === Constants.PSE_EXPERIENCE_DOCUMENT);
        break;
      case 'mbEducationLevelID':
        index = this.documentRefs.findIndex(d => d.name === Constants.MB_EXPERIENCE_DOCUMENT);
        break;
      case 'qcEducationLevelID':
        index = this.documentRefs.findIndex(d => d.name === Constants.QC_EXPERIENCE_DOCUMENT);
        break;
    }

    if(index != -1)
    {
      this.documentRefs[index].required = data.diplomaSelected;
      this.setRestrictedDocRefCount();
    }

  }

  setProfessionalDataFromApplicationChangeType(allProfessionals)
  {
    let newValue: any;
    let code = "";

    if(this.applicationDetail.newApplicationChangeTypes)
    {
      this.applicationDetail.newApplicationChangeTypes.forEach(NewApplicationChangeType => {
              
        if (this.draftMode && NewApplicationChangeType.dataType && NewApplicationChangeType.dataType != Constants.DATA_TYPE_FACILITY_NAME_CHANGE &&
          NewApplicationChangeType.dataType != Constants.DATA_TYPE_PREMISE_MODIFICATION && NewApplicationChangeType.dataType != 
          Constants.DATA_TYPE_NONE) {

          newValue = JSON.parse(NewApplicationChangeType.newValue);
        } else{
          newValue = NewApplicationChangeType.newValueObj;
        }

        switch (NewApplicationChangeType.changeType.changeTypeRef.name) {

          case Constants.HYGIENE_AND_SANITATION_EXPERT_NAME:
            code = "hse";
            break;

          case Constants.STORE_MANAGER_NAME:
            code = "sm";
            break;

          case Constants.QUALITY_ASSURANCE_NAME:
            code = "qa";
            break;

          case Constants.Quality_CONTROL_NAME:
            code = "qc";
            break;

          case Constants.PRODUCTION_MANAGER_NAME:
            code = "pm";
            break;

          case Constants.TECHNICAL_LEADER_NAME:
            code = "tl";
            break;

          case Constants.PHYSICO_CHEMICAL_EXPERT_Name:
            code = "pce";
            break;

          case Constants.MICROBIOLOGIST_Name:
            code = "mb";
            break;

          default:
            code = "";
        }

        if(code != ""){
          allProfessionals[code + "Name"] = newValue.name;
          allProfessionals[code + "EducationLevelID"] = newValue.educationLevelID;
          allProfessionals[code + "QualificationID"] = newValue.qualificationID;
          allProfessionals[code + "Experience"] = newValue.experience;
          allProfessionals[code + "Email"] = newValue.email;
          allProfessionals[code + "PhoneNumber"] =newValue.phone;
          allProfessionals[code + "ProfessionalLicenseNumber"] = newValue.regNumber;
          allProfessionals[code + "ProfessionalTypeID"] = newValue.professionalTypeID;
        }
        
      });
    }
  }

  productTypeChange(removeSpecificProduct = true){
    const product = this.productTypes.find( x => x.id === this.changeForm.value.facility.productTypeID);   
    const facilityType = this.facilityTypes.find(x => x.id === this.changeForm.value.facility.facilityTypeID);
    this.commonService.getFilteredSpecificProducts(this.changeForm.value.facility.facilityTypeID,
      this.changeForm.value.facility.productTypeID).subscribe(specificProducts => {
      this.specificProductList = specificProducts;
      if(product.name == Constants.PRODUCT_TYPE_MEDICINE && facilityType.name == Constants.MANUFACTURER){
        if(this.tempCOC){
          this.specificProductList = this.specificProductList.filter(s => s.name.trim() === Constants.SP_PHARM_MED_CHEMICALS);
        } else {
          this.specificProductList = this.specificProductList.filter(s => s.name.trim() !== Constants.SP_PHARM_MED_CHEMICALS);
        }
      } else if(product.name == Constants.PRODUCT_TYPE_MEDICINE && facilityType.name == Constants.IMPORTER){
        if(this.tempCOC){
          this.specificProductList = this.specificProductList.filter(s => s.name.trim() === Constants.SP_HUMAN_MED_SUPS);
        }
      }
      if(removeSpecificProduct){
        this.changeForm.get('facility').get('specificProductIDs').setValue([]);
      }           
    });

    if(product.name == Constants.PRODUCT_TYPE_FOOD && facilityType.name == Constants.MANUFACTURER){
      this.showFoodManufacturerMenu = true;
    }
  }

  saveNotAllowed(){
    return (this.applicationDetail && this.applicationDetail.applicationCategory && 
      (this.applicationDetail.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_CHANGE ||
      this.applicationDetail.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE) && 
      [Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.applicationDetail.applicationStatusCode));
  }

  handleSpecificProductChange(addChangeType){
    if (addChangeType) {
      this.basicInfoFields.push('specificProduct');
      if (this.specificProductList.length === 0) {
        this.fetchSpecificProducts();
        this.specificProductChanges(true);
      }
      this.changeForm.get('facility').get('specificProductIDs').setValidators([Validators.required]);
      if (this.selectedFacility.productTypeName !== Constants.PRODUCT_TYPE_TOBACCO) { // tobacco is the only one that has specific product but no specific product item
        this.changeForm.get('facility').get('specificProductItemIDs').setValidators([Validators.required]);
        this.showSpecificProductItem = true;
      }

      // food manufacturers will use the specific product item table instead of multiple select field
      if (this.selectedFacility.productTypeName === Constants.PRODUCT_TYPE_FOOD && this.selectedFacility.facilityTypeName === Constants.MANUFACTURER)
      {
        this.changeForm.get('facility').get('specificProductItemIDs').clearValidators();
      } else {
        this.changeForm.get('facility').get('specificProductItemIDs').setValidators([Validators.required])
      }

      if (this.tabList.indexOf('basicInformation') === -1) {
        this.tabList.splice(1, 0, 'basicInformation');
      }
    } else if (this.tabList.indexOf('basicInformation') > -1 && !addChangeType) {
      this.changeForm.get('facility').get('specificProductIDs').clearValidators();
      this.changeForm.get('facility').get('specificProductItemIDs').clearValidators();
      this.changeForm.get('facility').get('specificProductIDs').setValue(this.selectedAppDetail.specificProductIDs);
      this.changeForm.get('facility').get('specificProductItemIDs').setValue(this.selectedAppDetail.specificProductItemIDs);

      this.basicInfoFields.splice(this.basicInfoFields.indexOf('specificProduct'), 1);
      if (this.basicInfoFields.length === 0) {
        this.tabList.splice(this.tabList.indexOf('basicInformation'), 1);
      }
    }

    const product = this.productTypes.find( x => x.id === this.changeForm.value.facility.productTypeID);   
    const facilityType = this.facilityTypes.find(x => x.id === this.changeForm.value.facility.facilityTypeID);
    if(product.name == Constants.PRODUCT_TYPE_FOOD && facilityType.name == Constants.MANUFACTURER){
      this.showFoodManufacturerMenu = true;
    }
  }

  populateOwnershipObject(newValue) {
    if (newValue) {
      let ownership: any = {
        ownerName: this.changeForm.value.facility.ownerName,
        ownerPhone: this.changeForm.value.facility.ownerPhoneNumber,
        organizationTypeID: this.changeForm.value.facility.organizationTypeID,
        organizationType: this.ownershipTypes.find(ow => ow.id === this.changeForm.value.facility.organizationTypeID)
      };
      return ownership;
    } else {
      let ownership: any = {
        ownerName: this.selectedAppDetail.facility.ownerName,
        ownerPhone: this.selectedAppDetail.facility.ownerPhoneNumber,
        organizationTypeID: this.selectedAppDetail.facility.ownershipTypeID,
        organizationType: this.ownershipTypes.find(ow => ow.id === this.selectedAppDetail.facility.ownershipTypeID)
      };

      return ownership;
    }
  }

  populateOrganizationObject(newValue){
    let org = new Organization();
    if (newValue) {
        org.name = this.selectedOrganizationName;
        org.tinNumber = this.changeForm.value.facility.tinNumber;
        org.ownerName = this.changeForm.value.facility.ownerName;
        org.ownerPhone = this.changeForm.value.facility.ownerPhoneNumber;
        org.organizationTypeID = this.changeForm.value.facility.organizationTypeID;
        org.type = this.ownershipTypes.find(ow => ow.id === this.changeForm.value.facility.organizationTypeID);
    } else {
        org.name =  this.selectedAppDetail.facility.name;
        org.tinNumber = this.selectedAppDetail.facility.tinNumber;
        org.ownerName = this.selectedAppDetail.facility.ownerName;
        org.ownerPhone = this.selectedAppDetail.facility.ownerPhoneNumber;
        org.organizationTypeID = this.selectedAppDetail.facility.ownershipTypeID;
        org.type = this.ownershipTypes.find(ow => ow.id === this.selectedAppDetail.facility.ownershipTypeID);
    }

    return org;
  }

  fetchOrganizationFromTin(){
    const tinNumber = this.changeForm.get('facility').get('tinNumber').value;
    if(tinNumber == this.selectedAppDetail.facility.tinNumber){
      this.selectedOrganizationName = this.selectedAppDetail.facility.name;
      return;
    }
    if(tinNumber.length >= 10 && tinNumber.length <= 12 && tinNumber.match(/^[0-9]{10}(-[1-9]{1})?$/)){
      let tinClaim = new TinClaim();
      tinClaim.tin = tinNumber;
      this.spinner.show();
      this.facilityService.getTinData(tinClaim).subscribe(org => {
        this.spinner.hide();
        if(org){
          this.selectedOrganizationName = org.name;
        } else {
          this.alertService.error("Tin was not Found!");
        }
      }, err => {
        this.spinner.hide();
        this.alertService.error(this.errorHandlerService.handleApiError(err));
      })
    }

  }

  addSpecificProductItemClicked(template) {
    this.specificProductItemForm = this.fb.group({
      specificProductItemID: ['', Validators.required],
    });

    const spids = this.selectedSpecificProductItems.map(spi => spi.specificProductItemID);
    this.modalSpecificProductItems = this.specificProductItems.filter(spi => spids.indexOf(spi.id) === -1);
    this.modalTitle = "Add Specific Product Item";
    this.modalRef = this.modalService.show(template);
  }

  editSpecificProductItemClicked(template, index) {
    this.indexOfSelectedSpecificProductItem = index;
    
    const specificProdItem = this.selectedSpecificProductItems[index];
    this.specificProductItemForm = this.fb.group({
      specificProductItemID: [specificProdItem.specificProductItemID, Validators.required],
    });

    const spids = this.selectedSpecificProductItems.map(spi => spi.specificProductItemID).filter(id => id !== specificProdItem.specificProductItemID);
    this.modalSpecificProductItems = this.specificProductItems.filter(spi => spids.indexOf(spi.id) === -1);
    this.modalTitle = "Edit Specific Product Item";
    this.modalRef = this.modalService.show(template);
  }

  deleteSpecificProductItemModal(template, index){
    this.indexOfSelectedSpecificProductItem = index;
    this.modalRef = this.modalService.show(template);
  }

  specificProductItemModalCancelClicked(){
    this.closeSpecificProductItemModal();
  }

  specificProductItemModalSaveClicked(){
    if(this.indexOfSelectedSpecificProductItem !== -1) { //editing
      this.selectedSpecificProductItems.splice(this.indexOfSelectedSpecificProductItem, 1);
    }

    const formData = this.specificProductItemForm.value;
    let specificProdItemData = new FacilitySpecificProductItem(formData.specificProductItemID);
    specificProdItemData.specificProductItem = this.specificProductItems.find(spi => spi.id == formData.specificProductItemID);
    this.selectedSpecificProductItems.push(specificProdItemData);
    this.closeSpecificProductItemModal();
    this.fetchConfiguredProfessionals();
  }
  
  closeSpecificProductItemModal() {
    this.indexOfSelectedSpecificProductItem = -1;
    this.modalRef.hide();
  }

  deleteSpecificProductItem(){
    this.selectedSpecificProductItems.splice(this.indexOfSelectedSpecificProductItem, 1);
    this.closeSpecificProductItemModal();
    this.fetchConfiguredProfessionals();
  }

  isSpecificProdItemTableValid() {
    return this.selectedSpecificProductItems.length > 0;
  }

  isSpecificProductItemTableFIRDisabled() {
    if(this.applicationDetail && this.applicationDetail.applicationStatusCode === Constants.FIR_SUBMITTED){    
      let editFields: FIRItem[] = JSON.parse(this.applicationDetail.editedFields);
      let groupIndex = editFields.findIndex(item => item.name === 'Facility Information');
      if(groupIndex == -1){
        return this.isSpecificProdItemTableValid();
      }

      return this.isSpecificProdItemTableValid() && editFields[groupIndex].subItems.findIndex(item => item.name === 'Specific Product Item') === -1;
    }

    return false;
  }
}
